<template>
  <div 
    class="user-list-header m-vertical-5 is-grid"
    :fill="false"
    grid
  >
    <div class="is-col-2">
      <p>
        <small>
          Nom
        </small>
      </p> 
    </div>

    <div class="is-col-2">
      <p>
        <small>
          Slug
        </small>
      </p> 
    </div>

    <div class="is-col-6">
      <p>
        <small>
          Permissions
        </small>
      </p> 
    </div>

    <div class="is-col-2">
      <p>
        <small>
          Créé le
        </small>
      </p> 
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      entity: {
        type: String,
        required: true,
      },
    },
  }
</script>